<template>
	<v-container class="fill-height" fluid>
		<v-row align="center" justify="center">
			<v-col class="text-center">
				PAGE NOT FOUND!
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: "NotFound",
}
</script>

